// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__KyYnO","footer":"ModalError_footer__1IYBH"};